module.exports = __webpack_public_path__ + "img/ViewsIcon.f0f963d5.svg";